/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { SystemVariable } from './system-variable';

/**
 * Each possible value of `SystemVariable`
 */
export const SYSTEM_VARIABLE: SystemVariable[] = [
  'system__from_number',
  'system__to_number',
  'system__telecom_provider',
  'system__call_sid',
  'system__session_id',
  'system__agent_title',
  'system__date_utc',
  'system__time_utc'
];